import { render, staticRenderFns } from "./MmDeliveryEdit.vue?vue&type=template&id=ce386802&scoped=true&"
import script from "./MmDeliveryEdit.vue?vue&type=script&lang=js&"
export * from "./MmDeliveryEdit.vue?vue&type=script&lang=js&"
import style0 from "./MmDeliveryEdit.vue?vue&type=style&index=0&id=ce386802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce386802",
  null
  
)

export default component.exports